<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19.835C22 20.3654 21.7893 20.8741 21.4142 21.2492C21.0391 21.6243 20.5304 21.835 20 21.835H4C3.46957 21.835 2.96086 21.6243 2.58579 21.2492C2.21071 20.8741 2 20.3654 2 19.835V8C2 7.46957 2.21071 6.96086 2.58579 6.58579C2.96086 6.21071 3.46957 6 4 6Z"
      fill="#D5D8DC"
    />
    <path d="M8 9H6V2H18V9H16V4H8V9Z" fill="#363C43" />
    <path d="M22 11H2V14H22V11Z" fill="#3CB149" />
    <path d="M14 10H10V15H14V10Z" fill="#363C43" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>

<style></style>
